<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row" style="margin-top: 20px;">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="card">
            <div class="card-header">
              <strong>Low Stock List</strong>
            </div>
            <div class="card-body">
              <table class="table">
                <tr>
                  <th>ID</th>
                  <th class="text-left">Product</th>
                  <th>Current Stock</th>
                  <th>Min Stock</th>
                  <th>Vendor</th>
                </tr>
                <tbody>
                <tr v-for="p in lowStocksProducts">
                  <td>{{p.id}}</td>
                  <td class="text-left">{{p.title}}</td>
                  <td>{{p.currentStock}}</td>
                  <td>{{p.minStock}}</td>
                  <td>{{getVendorName(p.vendorId)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

    import {getVendors} from "../api/vendors";

    var XLSX = require('xlsx');
    import {millisToDate, getStateList} from "../api/utils";
    import {getLowStockProduct} from "../api/product";

    export default {
        name: "Home",
        data() {
            return {

              lowStocksProducts:[],
              vendors:[],
            }
        },
        components: {

        },
        created() {

        },
        mounted(){
          this.getVendors();
          this.getLowStockItems();
        },
        beforeDestroy() {
        },
        computed: {



        },
        methods: {
          getVendors: function() {
            let self = this;
            getVendors()
            .then(function(data) {
              if(data.success == true) {
                self.$data.vendors = data.item;
              }
            })
            .catch(function(err) {

            })
          },
          getLowStockItems:function() {
            let self = this;
            getLowStockProduct()
            .then(function(data) {
              if(data.success == true) {
                self.$data.lowStocksProducts = data.item;
              }
            })
            .catch(function(err) {

            })
          },
          getVendorName: function(id) {
            if(this.$data.vendors.length == 0) {
              return '';
            }

            for(let i = 0 ; i < this.$data.vendors.length ; i++) {
              if(this.$data.vendors[i].id == id) {
                return this.$data.vendors[i].title;
              }
            }
            return 'No Vendor';
          }

        }
    }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue